import React from 'react';
import './single-flag.scss';
import Logo from './logo';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const SingleFlag = ({ name, images, children, price }) => (
    <div className="singleFlag">
        <Logo black />
        <div className="stamp black" />
        <div className="flagContent">
            <div className="flagWrap">
                <Slider {...settings}>
                    {images.map((url) => (
                        <div className="slideWrap" key={url}>
                            <div className="slide" style={{ backgroundImage: `url(${url})` }} />
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="info">
                <div className="name">{name.toUpperCase()}</div>
                {children}
                <div className="buy">
                    <div className="price">£{price}</div>
                    <button
                        className="buyButton snipcart-add-item"
                        data-item-id={name}
                        data-item-price={price}
                        data-item-url="/"
                        data-item-description="Sed lacinia non quam sed varius."
                        data-item-image={images[0]}
                        data-item-name={name}
                    >ADD TO CART</button>
                </div>
            </div>
        </div>
    </div>
);

SingleFlag.propTypes = {
    name: PropTypes.string,
    images: PropTypes.array,
    children: PropTypes.node,
    price: PropTypes.number,
};

export default SingleFlag;
